(ns dashboard.views.browser-extension.client-environments.view
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [dashboard.config :as config]
            [dashboard.browser-extension :as extension]
            [clojure.string :as str]))

(rf/reg-sub
 ::env-history
 (fn [db [_]]
   (get-in db [:browser-extension :env-history])))

(defn client-environments-page []
  (let [env-name-atom (r/atom "")]
    (fn []
      (let [previous-envs @(rf/subscribe [::env-history])
            jump-disabled? (str/blank? @env-name-atom)
            jump-to-env (fn [env]
                          (rf/dispatch [::extension/send-event {:type :environment-selected
                                                                :env env}])
                          (reset! env-name-atom ""))]
        [:<>
         [:div.section
          [:p.title.is-5 "Welcome!"]
          [:p.subtitle.is-6 "Sign in to any client environment to start using the browser extension."]

          [:div.is-flex.is-justify-content-center.py-6
           [:img {:src "/img/repliance-icon.svg" :width "150px"}]]

          (when-not (empty? previous-envs)
            [:<>
             [:p.has-text-weight-bold.is-6.mb-2 "Jump to previously visited environments:"]
             (map
              (fn [env]
                [:a.button.is-outlined.is-fullwidth.is-link.mb-1
                 {:key env
                  :title (str "Load the extension view from client environment " env "." config/APPLICATION_BASE_DOMAIN)
                  :on-click (fn [e]
                              (.preventDefault e)
                              (jump-to-env env))}
                 env])
              previous-envs)])]
         [:div.section
          [:p.has-text-weight-bold.is-6.mb-2 (if (empty? previous-envs)
                                               "Jump to a client environment:"
                                               "Or go to a new environment:")]
          [:div
           [:div.field.has-addons
            [:div.control.is-expanded
             [:input.input {:type "text"
                            :on-key-down (fn [e]
                                           (when (= (.-key e) "Enter")
                                             (.preventDefault e)
                                             (jump-to-env @env-name-atom)))
                            :placeholder "client"
                            :value @env-name-atom
                            :on-change #(reset! env-name-atom (.. % -target -value))}]]
            [:div.control>a.button.is-static (str "." config/APPLICATION_BASE_DOMAIN)]]
           [:div.field>div.control>button.button.is-link.is-rounded.is-small
            {:on-click (fn [e]
                         (.preventDefault e)
                         (jump-to-env @env-name-atom))
             :title "Loads the extension view from the target environment. A login screen is shown, if not already logged in."
             :disabled jump-disabled?}
            "Let's Go"]]]]))))
